import Vue from 'vue';

const FormatKiB = {
  install(): void {
    Vue.prototype.formatKiB = (kib: number | null | undefined): string => {
      if (kib === null || kib === undefined || kib < 0) {
        return '0 MB';
      }

      // KiB to MB
      const mb = kib / 976.6;

      // If less than 1 GB -show in MB
      if (mb < 1000) {
        return `${mb.toFixed(2)} MB`;
      }

      // 1 GB or more - show in GB with 2 decimal
      const gb = mb / 1000;
      return `${gb.toFixed(2)} GB`;
    };
  },
};

export default FormatKiB;
